import type { RegisteredRouter, RouteIds } from "@tanstack/react-router"

// Covers the 4500ms slideDown animation the splash in index.html runs.
const SPLASH_MIN_MS = 4600

type RouteId = RouteIds<RegisteredRouter["routeTree"]>

export function splashHoldMs({
	seen,
	now,
}: {
	seen: boolean
	now: number
}): number {
	if (seen) return 0
	return Math.max(0, SPLASH_MIN_MS - now)
}

export function entryRouteIds(hasSession: boolean): RouteId[] {
	if (hasSession) return ["/_authenticated", "/_authenticated/home/"]
	return ["/onboarding", "/onboarding/language"]
}
